import React, { useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridRow,
  GridCell,
} from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import addIdToData from "../../utilities/addIdToData";
import API_BASE_URL from "../../utilities/apiConfig";
import { extractFileNameAndExtension } from "../../utilities/extractFileNameAndExtension";
import axios from "axios";
import convertToUnderscoreFormat from "../../utilities/convertToUnderscoreFormat";
import axiosInstance from "../../utilities/apiConfig";
export default function EligibleMembersTable({
  TableData,
  TableColumns,
  tableName,
  height = 450,
}) {
  // const DataWithId = addIdToData(TableData);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [profileImage, setProfileImage] = useState("");
  const [loading, setLoading] = useState(false);
  const baseURL = axiosInstance.defaults.baseURL;

  const handleRowClick = async (row) => {
    console.log(row);
    try {
      setLoading(true);
      const formattted_bar_id = convertToUnderscoreFormat(row.advocateBarId);
      const response = await axiosInstance.get(
        `/Verification/get_advocate_photo_using_advocate_bar_id/${formattted_bar_id}`
      );
      console.log(response.data);
      // if (response.data.response.statusCode === 200) {
      //   debugger;
      //   //setProfileImage(`${baseURL}/Verification/${response.data?.photo}`);
      //   // setProfileImage(
      //   //   `${axiosInstance}/Verification/${response.data?.photo}`
      //   // );
      //   axiosInstance
      //     .get(`${baseURL}/Verification/${response.data?.photo}`, {
      //       responseType: "blob", // Ensures we get binary data for the image
      //     })
      //     .then((imageResponse) => {
      //       const imageUrl = URL.createObjectURL(imageResponse.data); // Create a URL for the image blob
      //       setProfileImage(imageUrl); // Set the fetched image URL as the profile image
      //     })
      //     .catch((error) => {
      //       console.error("Error fetching profile image:", error);
      //     });
      //   setExpandedRowId(
      //     expandedRowId === row.eligibilityId ? null : row.eligibilityId
      //   );
      if (response.data.response.statusCode === 200) {
        debugger;

        axiosInstance
          .get(`/Verification/${response.data?.photo}`, {
            responseType: "blob", // Ensures we get binary data for the image
          })
          .then((imageResponse) => {
            const imageUrl = URL.createObjectURL(imageResponse.data); // Create URL for the image blob
            setProfileImage(imageUrl); // Set the fetched image URL as the profile image
          })
          .catch((error) => {
            console.error("Error fetching profile image:", error);
            setProfileImage(""); // Clear profile image if there's an error
          });

        setExpandedRowId(
          expandedRowId === row.eligibilityId ? null : row.eligibilityId
        );
      } else {
        setProfileImage("");
      }
    } catch (error) {
      setProfileImage("");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
        <GridToolbarFilterButton
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
        <GridToolbarDensitySelector
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
        {/* <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector
                    slotProps={{ tooltip: { title: 'Change density' } }}
                /> */}

        {/* <Box sx={{ flexGrow: 1 }} /> */}
        <GridToolbarExport
          slotProps={{
            tooltip: { title: "Export data" },
            button: { variant: "outlined" },
          }}
        />
      </GridToolbarContainer>
    );
  }

  const columns = TableColumns.map((col) => {
    if (col.field === "name") {
      return {
        ...col,
        renderCell: (params) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar
              src={`https://api.adorable.io/avatars/50/${params.value}.png`}
              style={{ marginRight: 8 }}
            />
            {params.value}
          </div>
        ),
      };
    }
    return col;
  });

  const rows = TableData.map((row) => ({
    ...row,
    eligibilityId: row.eligibilityId || row.advocateBarId,
  }));

  const renderExpandableContent = (row) => (
    <Collapse
      in={expandedRowId === row.eligibilityId}
      timeout="auto"
      unmountOnExit
    >
      <Box margin={1}>
        <div className="p-3 bg-light">
          <h4>Details for {row.name}</h4>
          <div className="row">
            <div className="col-md-3 rounded-5">
              <img src={profileImage} alt="" />
            </div>
            <div className="col-md-3"></div>
            <div className="col-md-6 ">
              <p>
                <strong>Serial No:</strong> {row.eligibilityId}
              </p>
              <p>
                <strong>Advocate Bar ID:</strong> {row.advocateBarId}{" "}
                {row.advocateAlternateBarId}
              </p>
              <p>
                <strong>Relative Name:</strong> {row.relationshipType} of{" "}
                {row.relativeName}
              </p>
              <p>
                <strong>Mobile No:</strong> {row.mobileNo}
              </p>
              <p>
                <strong>Date of Birth:</strong>{" "}
                {new Date(row.dateOfBirth).toLocaleDateString()}
              </p>

              <p>
                <strong>Local Address:</strong> {row.localAddress}
              </p>
              <p>
                <strong>Permanent Address:</strong> {row.permanentAddress}
              </p>
              {/* <p><strong>Years of Experience:</strong> {row.yearsOfExperience}</p>
                            <p><strong>Dehradun Bar Registration Date:</strong> {new Date(row.concernedBarRegistrationDate).toLocaleDateString()}</p> */}
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-6">
              {/* <p><strong>Membership Acceptance Date:</strong> {row.acceptedDate ? new Date(row.acceptedDate).toLocaleDateString() : 'N/A'}</p>
                            <p><strong>Blood Group:</strong> {row.bloodGroup || 'N/A'}</p>
                            <p><strong>Mentor Advocate Bar ID:</strong> {row.mentorAdvocateBarId || 'N/A'}</p>
                            <p><strong>Mentor Advocate Name:</strong> {row.mentorAdvocateName || 'N/A'}</p>
                            <p><strong>Chamber No:</strong> {row.chamberNo || 'N/A'}</p>
                            <p><strong>Mentor Joining Date:</strong> {row.joiningDate ? new Date(row.joiningDate).toLocaleDateString() : 'N/A'}</p>
                            <p><strong>Experience In:</strong> {row.experienceIn}</p>
                            <p><strong>Previous Department:</strong> {row.previousDepartment || 'N/A'}</p>
                            <p><strong>Retirement Year:</strong> {row.retirementYear ? new Date(row.retirementYear).getFullYear() : 'N/A'}</p> */}
            </div>
            <div className="col-md-6"></div>
          </div>
          {/* <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                        <Button variant="contained" color="success" onClick={() => handleAccept(row.eligibilityId)}>
                            Accept
                        </Button>
                        <Button variant="contained" color="error" onClick={() => handleReject(row.eligibilityId)}>
                            Reject
                        </Button>
                    </Box>
                    <p>Additional details can be added here...</p> */}
        </div>
      </Box>
    </Collapse>
  );

  const handleAccept = (eligibilityId) => {
    console.log("Accepted:", eligibilityId);
    // Handle accept action here
  };

  const handleReject = (eligibilityId) => {
    console.log("Rejected:", eligibilityId);
    // Handle reject action here
  };

  return (
    <div className="row justify-content-center mb-4">
      <div className="col-xxl-9">
        <div className="mt-5" style={{ height: height }}>
          <h2 className="mb-3 text-center">{tableName}</h2>
          <DataGrid
            rows={rows}
            columns={[
              {
                field: "expand",
                headerName: "",
                width: 50,
                filterable: false,
                sortable: false,
                hideable: false,

                renderCell: (params) => (
                  <IconButton onClick={() => handleRowClick(params.row)}>
                    {expandedRowId === params.row.eligibilityId ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </IconButton>
                ),
              },
              ...columns,
            ]}
            slots={{
              toolbar: CustomToolbar,
            }}
            components={{ Toolbar: CustomToolbar }}
            disableRowSelectionOnClick
            hideFooterPagination
            getRowId={(row) => row.eligibilityId}
          />
          {rows.map((row) => (
            <div key={row.eligibilityId}>
              {expandedRowId === row.eligibilityId && (
                <div style={{ gridColumn: "1 / -1" }}>
                  {renderExpandableContent(row)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
